<template>
	<TopNavFooter>
  <div class="main-content" id="admin" style="">
  <spinner :spinnerOn="loading"></spinner>
  <div class="modal dxpNewmodal" role="dialog" aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
            {{user_lang.activationTemplateTitle}}
          </div>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.dxpNewmodal')">&times;</button>
		      <h4 style="font-size: 18px;"></h4>
        </div>
        <div class="modal-body">
		      <div style="margin-right: 233px;width: 100%;text-align: left;">
		        <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		        {{user_lang.activationTemplateDescription}} </label>
		      </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" v-for = "data in dxpList">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            v-bind:value="data.id">
            <label 
            v-bind:for="data.id"> {{data.label}} {{user_lang.template}}</label>
          </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" v-for = "data in nonDxpList">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            checked="checked"
            v-bind:value="0">
            <label 
            v-bind:for="data.id">{{user_lang.cargillActivation}}</label>
          </div>
		      <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendDxpNewInvite" style="margin-top: 15px;">{{user_lang.activationOk}}</a>
        </div>
	    </div>
	  </div>
  </div>
  <div class="modal newdxpmodal1" role="dialog" 
  aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
            {{user_lang.activationTitle}}
          </div>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.newdxpmodal1')">&times;</button>
		      <h4 style="font-size: 18px;"></h4>
        </div>
        <div class="modal-body">
		      <div style="margin-right: 233px;width: 100%;text-align: left;">
		        <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		        {{user_lang.activationDescription}} </label>
		      </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" v-for = "data in dxpList">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            v-bind:value="data.id">
            <label 
            v-bind:for="data.id"> {{data.label}} {{user_lang.template}}</label>
          </div>
		      <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendDxpNewInvite" style="margin-top: 15px;">{{user_lang.activationOk}}</a>
        </div>
	    </div>
	  </div>
  </div>
  <div class="modal mfaresetmodal" role="dialog" aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.mfaResetModalTitle}}</div>
            <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.mfaresetmodal')"> &times;</button>
		        <h4 style="font-size: 18px;"></h4>
          </div>
          <div class="modal-body">
            <div v-if="!isAuthorizedForMFA" style="padding-left: 15px">{{errorMsgForMFA}}</div>
            <div v-if="mfaResetSuccess" style="padding-left: 15px">{{user_lang.factorResetSuccess}}</div>
            <div v-if="isAuthorizedForMFA && !mfaResetSuccess">
              <div style="margin-right: 233px;width: 100%;text-align: left;">
                <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
                {{user_lang.resetConfirmation}} </label>
              </div>
              <!-- <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="dxpnewcurrentId" /> -->
              <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="resetMFA" style="margin-top: 15px;">{{user_lang.yes}}</a>
              <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="closeModal('.mfaresetmodal')" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
            </div>
	      </div>
	    </div>
	  </div>
  </div>
  <div class="container-fluid" style="background: #fff;padding: 0px;padding-top:35px;">
    <div class="container">
      <div class="modal bulkReinviteMessageModal" role="dialog" aria-hidden="true">
	      <div class="modal-dialog" style="top:100px;">
          <div class="modal-content" style="color: #00524A;">
            <div class="bulk-upload-header" style="float:left;padding: 10px;font-weight:bold;">Bulk Reinvite Message
		          <button type="button" class="close" data-dismiss="modal" style="text-align: right;color:#fff;">&times;</button>
            </div>
            <div class="modal-body">
              {{reInviteMessage}}
	          </div>
	        </div>
	      </div>
      </div>
      <div class="modal bulkUploadOptionsModal" role="dialog" aria-hidden="true">
	      <div class="modal-dialog" style="top:100px;">
          <div class="modal-content" style="color: #00524A;">
		        <div class="bulk-upload-header" style="float:left;padding: 10px;font-weight:bold;">{{user_lang.bulkUploadOptionsLabel}}
		          <!-- <button type="button" class="close" data-dismiss="modal" style="text-align: right;color:#fff;">&times;</button> -->
            </div>
            <div class="modal-body">
              <div style="padding: 10px 20px 5px">
                <div class="checkboxgroup"><input type="radio" name="bulkUpload" id="bulkCreate" style="width: 20px; height: 20px" />
                <label for="bulkCreate" style="padding-left: 7px; font-weight: normal">{{user_lang.bulkCreateUsers}}</label></div>
                <div class="checkboxgroup"><input type="radio" name="bulkUpload" id="bulkReinvite" style="width: 20px; height: 20px" />
                <label for="bulkReinvite" style="padding-left: 7px; font-weight: normal">{{user_lang.bulkReinviteUsers}}</label></div>
              </div>
              <div style="padding-top:10px">
                <button type="button" class="btn btn-primary adduser-btn" @click="openbulkModals()"> {{user_lang.confirm}} </button>
                <button type="button" class="btn btn-primary adduser-btn" @click.prevent="closeModal('.bulkUploadOptionsModal');clearSelectedOptions()"> {{user_lang.cancel}} </button>
              </div>
              <div style="color:#ff0000; padding:10px 20px 5px" v-if="optionsNotSelected">Please select an option to proceed.</div>
              <!-- <ol type="1">
                <li style="display:list-item"><div class="bulk-list" @click="openbulkModals('bulkCreate')">Bulk Create Users</div></li>
                <li style="display:list-item"><div class="bulk-list" @click="openbulkModals('bulkReinvite')">Bulk Re-Invite Users</div></li>
              </ol> -->
	          </div>
          </div>
	      </div>
      </div>
      <div class="modal bulkReinviteModal" role="dialog" aria-hidden="true">
	      <div class="modal-dialog" style="top:100px;">
          <div class="modal-content" style="color: #00524A;">
		        <div class="bulk-upload-header" style="float:left;padding: 10px;font-weight:bold;">{{user_lang.bulkReinviteUsers}}
		          <button type="button" class="close" data-dismiss="modal" style="text-align: right;color:#fff;" @click="clearSelectedOptions()">&times;</button>
            </div>
            <div class="modal-body">
              <div style="margin-bottom:15px;">{{user_lang.downloadExcelTemplate}} <a href="../../static/Reinvite_template.xlsx" download><i class="fa fa-download" style="cursor: pointer;font-size: 25px;margin-left: 10px;"></i></a></div>
		          <div style="margin-bottom: 15px;color: #000;font-size: 14px;">{{user_lang.uploadInstruction}}</div>
		          <div style="padding:0px 0px 10px 20px;">
                <div><i class="fa fa-exclamation-triangle bulk-upload-warning"></i>{{user_lang.uploadWarningOne}}</div>
                <div><i class="fa fa-exclamation-triangle bulk-upload-warning"></i>{{user_lang.uploadWarningTwo}}</div>
                <div><i class="fa fa-exclamation-triangle bulk-upload-warning"></i>{{user_lang.uploadWarningThree}}</div>
                <div style="padding: 5px"><b>{{user_lang.note}}</b> {{user_lang.uploadNote}} </div>
              </div>
              <div style="font-size:14px;padding-right:30px;background:#eceff1;padding:12px 15px;vertical-align: -moz-middle-with-baseline;vertical-align: -webkit-baseline-middle;" v-if="adminType === 'admin' || adminType === 'superadmin'">{{user_lang.bulkReinviteUsers}}:
                <input type="file" id="reinviteFile" ref="reinviteFile" v-on:change="handleFileUpload(true)" style="border: none !important;padding: 0px !important;color:#000 !important;width:220px;background: transparent !important;" v-if="uploadReady"/>
	              <button type="button" class="btn btn-primary" v-on:click="submitFile(true)" style="padding: 5px 10px;font-size: 14px !important;font-weight: bold;" v-bind:class="{'disabled': !isExcel}">{{user_lang.uploadLabel}}</button>
	            </div>
	          </div>
	        </div>
	      </div>
      </div>
	    <div class="modal bulkCreateModal" role="dialog" aria-hidden="true">
	      <div class="modal-dialog" style="top:100px;">
          <div class="modal-content" style="color: #00524A;">
		        <div class="bulk-upload-header" style="float:left;padding: 10px;font-weight:bold;">{{user_lang.bulkCreateUsers}}
		          <button type="button" class="close" data-dismiss="modal" style="text-align: right;color:#fff;" @click="clearSelectedOptions()">&times;</button>
            </div>
            <div class="modal-body">
		          <div style="margin-bottom:15px;">{{user_lang.downloadExcelTemplate}} <a href="../../static/template.xlsx" download><i class="fa fa-download" style="cursor: pointer;font-size: 25px;margin-left: 10px;"></i></a></div>
		          <div style="margin-bottom: 15px;color: #000;font-size: 14px;">{{user_lang.uploadInstruction}}</div>
		          <div style="padding:0px 0px 10px 20px;">
		            <div><i class="fa fa-exclamation-triangle bulk-upload-warning" ></i>{{user_lang.uploadWarningOne}}</div>
		            <div><i class="fa fa-exclamation-triangle bulk-upload-warning" ></i>{{user_lang.uploadWarningFour}}</div>
		            <div><i class="fa fa-exclamation-triangle bulk-upload-warning" ></i>{{user_lang.uploadWarningFive}}</div>
		            <div><i class="fa fa-exclamation-triangle bulk-upload-warning" ></i>{{user_lang.uploadWarningSix}}</div>
                <div style="padding: 5px"><b>{{user_lang.note}}</b> {{user_lang.uploadNote}}</div>
		          </div>
	            <div style="font-size:14px;padding-right:30px;background:#eceff1;padding:12px 15px;vertical-align: -moz-middle-with-baseline;vertical-align: -webkit-baseline-middle;" v-if="adminType === 'admin' || adminType === 'superadmin'">{{user_lang.bulkCreateUsers}}:
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload(false)" style="border: none !important;padding: 0px !important;color:#000 !important;width:220px;background: transparent !important;" v-if="uploadReady"/>
	              <button type="button" class="btn btn-primary" v-on:click="submitFile(false)" style="padding: 5px 10px;font-size: 14px !important;font-weight: bold;" v-bind:class="{'disabled': !isExcel}">{{user_lang.uploadLabel}}</button>
	            </div>
	          </div>
	        </div>
	      </div>
      </div>
	  <div v-show = "isShow || updateToggle" style="margin:-15px">
	  <div class="bc-adduser">
	  <span v-on:click="goToUserManagement()" class="bc-nav">{{user_lang.userAdministration}}</span>&nbsp; / &nbsp;<span>
	  {{updateToggle ? user_lang.edituser : user_lang.adduser}}</span>
      <div style="font-size: 44px !important;font-weight: bold;overflow: auto;margin-bottom: 15px;"><span>{{updateToggle ? user_lang.edituser : user_lang.adduser}}</span></div>
	  <div style="margin-top: 10px;" class="error-bg usercreateinfo" id="formValidation" v-for = "i in addUserValidations">
	  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "addUserValidations = []"></i></div>
		  <div style="display: inline-block;margin: 5px 5px;"><i class="fa fa-info-circle" style="font-size: 25px;"></i></div>	<span>{{i}}</span></div>
	  </div>
      <div class="card-block" style="background:#f1f1f1 !important; margin-bottom: 10px;padding: 18px 18px;">
	  <div class="user-creds">
	 <div class="row">
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
	  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.first_name}}:</label>
          <span class="wrap-input"><input class="form-control input-adduser"  v-bind:class = "{disabled : !isNameEditable && updateToggle}" id="message-text"
		  v-model="addUserFirstName" /></span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
	  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.last_name}}:</label>
          <span class="wrap-input"><input class="form-control input-adduser" v-bind:class = "{disabled : !isNameEditable && updateToggle}" id="message-text" v-model="addUserLastName" /></span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.primary_mail}}:</label>
          <span class="wrap-input"><input class="form-control input-adduser" v-bind:class = "{disabled : updateToggle}"
		  id="message-text" v-model="addUserPrimaryEmail" /></span>
		  </div>
	  </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.secondary_mail}}:</label>
          <span class="wrap-input"><input class="form-control input-adduser" 
		  id="message-text" v-model="addUserSecondaryEmail" /></span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div v-bind:class = "{disabled : updateToggle}">
          <label for="message-text" class="form-control-label">{{user_lang.selectLang}}:</label>
          <span class="wrap-input">
		  <select v-model = "prefLang" class="preflang" id="message-text" style="height:39px;">          
		<option v-for= "i in lang_def" v-bind:value="i.langCode">{{i.langName}}</option>
          </select>
 </span>
          </div>
	  </div>
	  <!--div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div class = "disabled">
          <label for="message-text" class="form-control-label">{{user_lang.selectBrand}}:</label>
          <span class="wrap-input">
		  <select v-model = "brand" class="preflang" id="message-text" style="height:39px;">
          <option v-bind:value="i.brandKey.toLowerCase()" v-for = "(i, index) in brandDetails.data">{{i.brandName}}</option>
          </select>
 </span>
          </div>
	  </div-->
	  </div>
	  </div>
    <div v-if="isEdit" class="user-creds" style="padding-bottom: 7px">
      <div class="row" style="padding: 5px 15px 0px">
        <div class="row" style="padding-left: 15px; width: 100%;">
          <label style="font-size: 16px">{{user_lang.viewMoreInfo}}</label>
          <span class="fa fa-info-circle date-info" data-toggle="tooltip" 
          v-bind:title="user_lang.infoContent" :data-original-title="user_lang.infoContent"></span>
          <i v-on:click="toggleDateFields" id="toggle-arrow" class="fa fa-angle-right" style="padding: 3px 10px; font-size: 20px; cursor: pointer;"></i>
        </div>
        <div id="toggle-data" style="width: 100%; display: none">
          <div class="row date-field-edit">
            <label>{{user_lang.createdDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip" 
            v-bind:title="user_lang.createdDateDescription" :data-original-title="user_lang.createdDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.createdDate}}</div>
          </div>
          <div class="row date-field-edit">
            <label>{{user_lang.activatedDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip" 
            v-bind:title="user_lang.activatedDateDescription" :data-original-title="user_lang.activatedDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.activatedDate}}</div>
          </div>
          <div class="row date-field-edit">
            <label>{{user_lang.lastLoginDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip"
            v-bind:title="user_lang.lastLoginDateDescription" :data-original-title="user_lang.lastLoginDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.lastLogin}}</div>
          </div>
          <div class="row date-field-edit">
            <label>{{user_lang.lastUpdatedDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip"
            v-bind:title="user_lang.lastUpdatedDateDescription" :data-original-title="user_lang.lastUpdatedDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.lastUpdated}}</div>
          </div>
          <div class="row date-field-edit">
            <label>{{user_lang.passwordChangedDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip"
            v-bind:title="user_lang.passwordChangedDateDescription" :data-original-title="user_lang.passwordChangedDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.passwordChanged}}</div>
          </div>
          <div class="row date-field-edit">
            <label>{{user_lang.statusChangedDate}}</label>
            <span class="fa fa-info-circle date-info" data-toggle="tooltip"
            v-bind:title="user_lang.statusChangedDateDescription" :data-original-title="user_lang.statusChangedDateDescription"></span>
            <span class="separator"><b>: </b></span>
            <div col="3" class="date-value-edit">{{dateInfo.statusChanged}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isEdit" class="user-creds" style="padding-bottom: 7px">
      <div class="row" style="padding: 5px 15px 0px">
        <div class="row" style="padding-left: 15px; width: 100%;">
          <label style="font-size: 16px">{{user_lang.resetMFATitle}}</label>
          <!-- <span class="fa fa-info-circle date-info" data-toggle="tooltip" 
          v-bind:title="user_lang.infoContent" :data-original-title="user_lang.infoContent"></span> -->
          <i v-on:click="toggleMFAField" id="toggle-mfa-arrow" class="fa fa-angle-right" style="padding: 3px 10px; font-size: 20px; cursor: pointer;"></i>
        </div>
        <div v-if="userFactorList.length === 0" id="toggle-mfa-data" style="width: 100%; display: none; padding: 5px;">
          {{user_lang.noFactorExist}}
        </div>
        <div v-if="userFactorList.length > 0" id="toggle-mfa-data" style="width: 100%; display: none; padding: 5px;">
          <div v-bind:key="factor.id" v-for="factor in userFactorList" class="mfa-list">
            <div class="checkboxgroup">
            <input type="radio" name="mfaReset" v-bind:id="factor.id" style="width: 20px; height: 20px" />
            <label v-bind:for="factor.id" style="padding-left: 7px; font-weight: normal">{{factor.factorType.indexOf('token:software:totp') > -1 ? transformText(factor.provider) : transformText(factor.factorType)}}</label>
            </div>
          </div>
          <div class="validation-mfa" v-if="noFactorSelected">{{user_lang.mfaValidation}}</div>
          <button class="btn btn-primary mfa-btn" v-on:click="checkAccess"> {{user_lang.resetButton}}</button>
        </div>
      </div>
    </div>
	  <div class="user-creds">
	  <div style="font-size:14px;font-weight:bold;">{{user_lang['assignApplication']}}</div>
	  <div class="row">
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="padding-top:5px;">
	  <div class="form-wrap">
		  <div id="dropdown" class="">
			<div class="selectDropDown" v-on:click= "showDropDown = !showDropDown"> <span style="padding-left: 5px;">{{user_lang['selectgroups']}}<i class="fa fa-caret-down"
			style="float: right;margin: 4px 5px;"></i></span></div>
            <div v-for="(n, index) in adminToBrands" v-show="showDropDown && ((appUrl.indexOf('identity-dev') > -1) || (appUrl.indexOf('cargill') > -1) || (n.toLowerCase() !== 'cargill' && appUrl.indexOf(n.toLowerCase().replace('portal','')) > -1) || appUrl.indexOf('localhost') > -1)" 
			v-bind:class = "{disabled: checkedAppBrand !== '' && (n.toLowerCase() !== checkedAppBrand.toLowerCase())}">
            <span class= "admintobrand">{{n}}</span>
			 <div id="checkboxlist" v-show="showDropDown">
					<div v-for="(i, index) in userAppList" style="padding-right: 15px;padding-left: 5px;" class="dd-list-item" 
					v-if = "adminTo.indexOf(i.id) > -1 && n === i.brand">
					  <input v-bind:id = "i.id" class="form-control input-checkbx" type="checkbox" v-bind:value = "i.groupId + '-' + i.adminGroupName" />
					  <label style="vertical-align: super; display: inline" v-bind:for = "i.id">{{i.label}} <label v-if="i.adminGroupName"> - {{i.adminGroupName}} </label></label>
					  </div>
					</div>
            </div>
			</div>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="padding-top:5px;" v-show="brand !== ''">
	  <span style="font-weight:bold;">{{user_lang.selectedBrand}} </span><span style="text-transform: capitalize;">{{brand}}</span>
	  </div>
			</div>
	<div class="row" style="margin-top:10px">
	<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
	  <div style="font-size:14px;font-weight:bold;">{{user_lang['availablegroups']}}:</div>
	  	  <div style="padding:10px">
	  <div v-for="(i,index) in availablegroups" class="group-div" v-bind:class="{disabled: i.isDisabled, bb0 : index !== (availablegroups.length-1)}" v-if="checkAllowedSubGroup('all', i.id)">
    <div style="pointer-events: auto; cursor: default;" :data-toggle="i.isDisabled ? 'tooltip': false" 
      v-bind:title="disableAvailableGroups(i.isDisabled)" :data-original-title="disableAvailableGroups(i.isDisabled)">
	  <div class="group-name">{{i._embedded ? i._embedded.group.profile.name : i.profile.name}}</div>
	  <i v-if="!i.isDisabled" class="fa fa-plus-circle add-group" v-on:click="addToSelectedGroup(i.id)"></i></div>
	  </div>
	  </div>
	  <div style="font-size:14px;font-weight:bold;">{{user_lang.availableIndependentGroups}}</div>
	  	  <div style="padding:10px">
	  <div v-for="(i,index) in indieGroupsForNewUser" class="group-div"
	  v-bind:class="{disabled: i.isDisabled, bb0 : index !== (indieGroupsAdministered.length-1)}"
	  v-if="checkAllowedSubGroup('all', i.groupId.split('~~~')[0]) && !isPresentInSelectedGroups(i.groupId.split('~~~')[0]) && i.groupId.split('~~~')[1]">
    <div style="pointer-events: auto; cursor: default;" :data-toggle="i.isDisabled ? 'tooltip': false" 
      v-bind:title="disableAvailableGroups(i.isDisabled)" :data-original-title="disableAvailableGroups(i.isDisabled)">
	  <div class="group-name">{{i.groupId.split('~~~')[1]}}</div>
	  <i v-if="!i.isDisabled" class="fa fa-plus-circle add-group" v-on:click="addToSelectedIndieGroup(i.groupId.split('~~~')[0])"></i></div>
	  </div>
	  </div>
	</div>
	<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
	  <div style="font-size:14px;font-weight:bold;">{{user_lang['selectedgroups']}}</div>
	  	  <div style="padding:10px">
	<div v-for="x in grouplist" v-show = "isChildren(x.id)" style="padding-right: 15px;padding-left: 5px;display: block;font-weight:bold;"
	class="dd-list-item" v-bind:class = "{disabled: adminTo.indexOf(x.id) === -1}">
				{{x.label}}
	  <div v-for="(i, index) in selectedgroups" v-show = "x.id === i.appId"
	  style="font-weight: normal;" class="group-div" v-bind:class="{disabled: i.isDisabled || !checkAllowedSubGroup('all', i.id), bb0 : index !== (selectedgroups.length-1)}">
    <div style="pointer-events: auto; cursor: default;" :data-toggle="i.isDisabled || !checkAllowedSubGroup('all', i.id) ? 'tooltip': false" 
      :title="disableSelectedGroups(i.isDisabled, i.id)" :data-original-title="disableSelectedGroups(i.isDisabled, i.id)">
	  <div class="group-name">{{i._embedded ? i._embedded.group.profile.name : i.profile.name}}</div>
	  <i v-if="!i.isDisabled && checkAllowedSubGroup('all', i.id)" class="fa fa-minus-circle remove-group" v-on:click = "removeFromSelectedGroup(i.id)"></i></div>
	  </div>
	  </div>
	  <div style="padding-right: 15px;padding-left: 5px;display: block;font-weight:bold;" class="dd-list-item">
	  <div v-for="(i, index) in selectedIndiegroups" style="font-weight: normal;"
	  class="group-div" v-bind:class="{disabled: !checkAllowedSubGroup('all', i.split('~~~')[0]), bb0 : index !== (selectedIndiegroups.length-1)}">
    <div style="pointer-events: auto; cursor: default;" :data-toggle="!checkAllowedSubGroup('all', i.split('~~~')[0]) ? 'tooltip': false" 
      :title="disableSelectedIndieGroups(i.split('~~~')[0])" :data-original-title="disableSelectedIndieGroups(i.split('~~~')[0])">
	  <div class="group-name">{{i.split('~~~')[1]}}</div>
	  <i v-if="checkAllowedSubGroup('all', i.split('~~~')[0])" class="fa fa-minus-circle remove-group" v-on:click="removeFromSelectedIndieGroup(i.split('~~~')[0], 'indie')"></i></div>
	  </div>
	  </div>
	  <div style="margin-top:20px;padding: 0px 15px 0px 5px">
	  <div v-for="(i, index) in selectedGroupsOutsideAdmin" style="font-weight: normal;"
	  class="group-div" v-bind:class="{disabled: adminTo.indexOf(i.id) === -1 && !checkAllowedSubGroup('all', i.id), bb0 : index !== (selectedGroupsOutsideAdmin.length-1)}"
	  v-if = "i.id != onecargillusersgroupid && i.id != onecargilladmingroupid">
    <div style="pointer-events: auto; cursor: default;" :data-toggle="adminTo.indexOf(i.id) === -1 && !checkAllowedSubGroup('all', i.id) ? 'tooltip': false" 
      :title="disableSelectedGroupsOutsideAdmin(i.id)" :data-original-title="disableSelectedGroupsOutsideAdmin(i.id)">
	  <div class="group-name">{{i._embedded ? i._embedded.group.profile.name : i.profile.name}}</div>
	  <i v-if="!(adminTo.indexOf(i.id) === -1 && !checkAllowedSubGroup('all', i.id))" class="fa fa-minus-circle remove-group" v-on:click = "removeFromSelectedIndieGroup(i.id)"></i></div>
	  </div>
	  </div>
	  	  </div>
	</div>
	</div>
				</div>
		  <div v-show = "userAlreadyExists" v-on:click="goToExistingUser()"
		  style="margin-top: 10px;cursor:pointer;text-decoration:underline;color: #444444;font-weight: bold;">
		  {{user_lang.viewuser}}</div>
		  <div style="height:40px;">
		  <button type="button" class="btn btn-primary create-btn" data-dismiss="modal"
		  v-on:click="updateToggle ? updateUser() : displayActivateModal()" v-bind:class = "{disabled : addUserPrimaryEmail === loggedInUser && updateToggle}">
		  {{updateToggle ? user_lang.update:user_lang.inviteuser}}
            <!--div v-if="showLoading === 'false'"> </div-->
            <!--div v-else> <scale-loader :color="color" :height="height"></scale-loader> </div-->
          </button>
		  <span v-on:click="goToUserManagement()" class="cancel-btn">{{user_lang.cancel}}</span>
		  </div>
        </div>
		</div>
		<div v-show = "!isShow && !updateToggle">
		<div class="bc">
	  <span>{{user_lang.userAdministration}}</span>
	  </div>
        <!-- BEGIN: TITLE & TITLEBAR / CONTRACT DETAIL # -->
        <!--div class="titleBar" style="margin:10px 0px"></div> -->
        <div style="font-size: 44px !important;font-weight: bold;overflow: auto;margin-bottom: 20px;"><span>{{user_lang.userAdministration}}</span>
		<div style="float: right;margin-top: -5px;">	   
	<button 
  v-if="(hostName.toLowerCase() === 'localhost:8080' || hostName.toLowerCase() === 'cargillcustomer.dev.dev-cglcloud.com' || hostName.toLowerCase() === 'cargillcustomer.stage.cglcloud.in' || hostName.toLowerCase() === 'identityservices.stage.mycargill.com' || hostName.toLowerCase() === 'identityservices-deprecated.mycargill.com' || hostName.toLowerCase().indexOf('identity-deprecated.mycargill') !== -1)"
  type="button" class="btn btn-primary adduser-btn"
					v-on:click="showBulkUploadWindow(), clearAddUserFields(), removeAllNotifications()">
				{{user_lang.bulkUploadLabel}}</button>
	<button type="button" class="btn btn-primary adduser-btn"
					v-on:click="isShow = !isShow, updateToggle = false, clearAddUserFields(), removeAllNotifications()">
				{{user_lang.adduser}}</button>
		</div>
		</div>
          <div class="usercreateinfo" id="userCreationMessage" v-show="userCreationMessage == user_lang['usercreated']">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "userCreationMessage = ''"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;">{{user_lang.emailsenttouser}} {{addUserFirstName}} {{addUserLastName}}
		  <div style="font-weight: normal;">{{user_lang.pendingactivation}}</div></div>
		  </div>
		  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="resetSuccess">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "resetSuccess = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;">{{user_lang.resetsuccesspopupmsg}}
		  </div>
		  </div>
		  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="activateSuccess">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "activateSuccess = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.activatesuccess}} {{reverseTransformEmail(activatedemail)}}
		  </div>
		  </div>
		  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="updatesuccess">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "updatesuccess = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.updatesuccess}}
		  </div>
		  </div>
		  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="deactivateSuccess">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "deactivateSuccess = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{reverseTransformEmail(activatedemail)}} {{user_lang.deactivatesuccess}}
		  </div>
		  </div>
		  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="deleteSuccess">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "deleteSuccess = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{reverseTransformEmail(activatedemail)}} {{user_lang.deletesuccess}}
		  </div>
		  </div>
<div class="row">
	  <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" v-bind:class = "{disabled : globalsearch}">
	  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.filteruser}}</label>
          <span class="wrap-input">
		  <select style="max-height: 40px;padding: 9px;margin-top: 0px;width:100%;height:40px;" v-model = "selectedAppId" id="selectApp" @change = "filterApp">
				<option v-bind:value="i.id" v-for = "(i, index) in appList" v-if = "adminTo.indexOf(i.id) > -1 && i.name !== 'bookmark' && !isAlreadyPresent(i.id, index)">{{i.label}}</option>
			</select>
		  </span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" v-bind:class = "{disabled : globalsearch}">
	  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.filterusergrp}}</label> <span class="report-link" @click="resetTotalCount();downloadUsersOfGroupRecursively();">
          <progress id="file" v-bind:value="downloadReportSet.length" v-bind:max="reportTotalCount" style="width: 100px;height: 7px;" v-show="showProgress">  </progress><span v-show="showProgress" style="font-size:16px;color:#000;margin-right:10px;margin-left:5px;">{{reportTotalCount ? ((downloadReportSet.length/reportTotalCount)*100).toFixed(0) : '0'}}%</span>{{user_lang.reportLabel}}<i data-v-04fb9444="" class="fa fa-download" style="cursor: pointer;font-size: 16px;"></i></span> 
          <span class="wrap-input">
		  <select style="max-height: 40px;padding: 9px;margin-top: 0px;width:100%;height:40px;" v-model = "selectedGroupId" @change = "filterGroup" id="grpdd">
				<!--option value="all">{{user_lang.allactiveusers}}</option-->
				<option v-bind:value="j.id" v-for = "j in appGroupMap[selectedAppId]" v-if="checkAllowedSubGroup(selectedAppId, j.id)">{{j._embedded.group.profile.name}}</option>
				<option v-bind:value="j.split('~~~')[0]" v-for = "j in admingrpmodalfirstsubgrpidlist" v-if="j.indexOf('~~~') > -1">{{j.split('~~~')[1]}}</option>
			</select>
			</span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
		  <div class="form-wrap">
          <label for="message-text" class="form-control-label">{{user_lang.search}}</label>
		  <label class="form-control-label" style="float: right;min-width: 0px;">{{user_lang.globalsearch}}</label>
		  <input type="checkbox" v-model="globalsearch" class="gsearch" style="float: right;margin-right: 10px;"/>
          <span class="wrap-input">
		  <div style="float:right">
		  <button class="btn btn-secondary search-icon">
			<i class="fa fa-search"></i>
		</button>
			</div>
			<div style="overflow:hidden;">
			<span class="searchinfotext" v-show = "!globalsearch">{{user_lang.searchinfotext}}</span>
			<input type="text" id="searchId" class="form-control" v-model="searchTerm"
			style="margin-left: 0px !important;margin-top: 0px;    margin-bottom: 0px !important;width: 100% !important;">
			</div>
			</span>
		  </div>
	  </div>
	  </div>
      <div class="row tableContainer" style="margin-top:0; border:0;background: #eceff1">
        <div class="card-block1">
          <!-- Tab panes -->
            <!-- Search Users tab -->
            <div id="search" class="tab-pane" role="tabpanel">
				<div class="input-group" >
				<div class="search-bar-wrapper">
			<div>
			</div>
			</div>
					<!--div class="sub-group" style="display:flex;width:50%">
					<span style="line-height: 40px;margin-left: 0px;white-space: nowrap;" class="filter-text">{{user_lang['filteruser']}}</span>
					<select style="margin-left: 5px;max-height: 40px;padding: 9px;margin-top: 0px;width:100%" v-model = "selectedAppId" @change = "filterApp">
					<option v-bind:value="i._embedded.user._links.group.href.split('/').pop()" v-for = "i in grouplist">{{i.label}}</option>
					</select>
					</div>
					<div class="sub-group" style="display:flex;width:50%">
					<input type="text" id="searchId" class="form-control"
						v-model="searchTerm" style="margin-left: 20px !important;margin-top: 0px;    margin-bottom: 0px !important;float: left;min-width: 150px;"> <span class="input-group-btn">
						<button class="btn btn-secondary search-icon">
							<i class="fa fa-search"></i>
						</button>
					</span>
					</div>
					<div class="sub-group">
                    </div-->
				</div>
				<div style="margin-bottom:10px;"></div>
				<UserTable :adminAppsArray=adminAppsArray :filterAppId = selectedAppId :filterGroupId = selectedGroupId :usercreated = userCreationMessage
				:searchTerm=searchTerm :globalsearch=globalsearch :adminTo = adminTo></UserTable>
            </div>
          </div>  <!-- END: tab panes -->
        </div>  <!-- END: -->
      </div>
	  </div>
    </div>
    </div>
</TopNavFooter>
</template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import Vue from 'vue';
  import Blob from 'blob';
  // import cloneDeep from 'lodash.clonedeep';
  import UserTable from '../components/UserTable'
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  // import SlimSelect from 'slim-select'
  import axios from 'axios'
  import storage from '@/helpers/storage'
  const apiUrl = process.env.API_URL;
  const serviceAccountGroupId = process.env.SERVICE_ACCOUNT_GROUP_ID;
  const internalUserDomains = require('../internalUserEmailDomains.json').data;
  const onecargilladmingroupid = process.env.ONECARGILL_ADMIN_GROUP_ID;
  const onecargillapplicationgroupid = process.env.ONECARGILL_APPLICATION_GROUP_ID;
  const onecargillappid = process.env.KEY_ID;
  const brandDetails = require('../brand-details.json');
  export default {
    name: 'adminold',
    components: {
      TopNavFooter,
      UserTable,
      Spinner
    },
    created() {
      var self = this;
      this.user_lang = this.lang_br
      self.loading = false
      self.loggedInUser = storage.get('email')
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
      var uid = storage.get('cf-user')
      if (uid !== undefined && uid !== null) {
        var userId = storage.get('cf-user').sub
        console.log(userId)
      } else {
        self.$router.push({path: '/LoggingIn'})
      }
    },
    mounted() {
      var self = this
      $(document).ready(function() {
        $("body").tooltip({
          animation: false,
          selector: '[data-toggle=tooltip]'
        });
      });
      userId = storage.get('cf-user').sub
      // console.log(brandDetails);
      self.indieGroupsAdministered = []
      var userId = storage.get('cf-user').sub
      idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${userId}/groups`).then(function (response) {
        response.data.forEach(x => {
          self.userGroups.push(x.id)
        })
        storage.set('grpsOfUser', JSON.stringify(response.data))
        self.getAppGroupConfigData()
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupListNew`).then(function (response) {
          self.mountPage(response);
          self.filterApp();
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      })
      self.eventHandlers()
    },
    methods: {
      downloadReport() {
        var self = this
        self.loading = true
        idmApi.downloadReport(`${apiUrl}/auth/report/${self.selectedGroupId}`).then(function(response) {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Report.xlsx'
          self.loading = false
          link.click()
        }).catch(error => {
          window.alert(error)
          self.loading = false
        })
      },
      disableAvailableGroups(isDisabled) {
        return isDisabled ? this.user_lang.readOnlyGroup : false;
      },
      disableSelectedGroups(isDisabled, id) {
        return isDisabled ? this.user_lang.readOnlyGroup : !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false;
      },
      disableSelectedIndieGroups(id) {
        return !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false
      },
      disableSelectedGroupsOutsideAdmin(id) {
        return this.adminTo.indexOf(id) === -1 && !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false
      },
      getAppGroupConfigData() {
        var self = this
        idmApi.getAppGroupConfigData(`${apiUrl}/auth/fetchUserApps`, self.userGroups).then(function(response) {
          console.log(response)
          self.adminConfigFiltered = response.data
        }).catch(error => {
          console.log(error)
        })
      },
      mountPage(response) {
        var self = this
        var adminGroupsArr = []
        var adminAppsArr = []
        self.appAdminGroupModal = response.data
        var lenn = self.appAdminGroupModal.filter(x => x.applicationId === self.selectedAppId).length
        if (lenn > 0) {
          // self.admingrpmodalfirstsubgrpidlist = ((self.appAdminGroupModal.filter(x => x.applicationId === self.selectedAppId))[0]).subGroupId
          let grpsOfUser = JSON.parse(storage.get('grpsOfUser'));
          self.admingrpmodalfirstsubgrpidlist = []
          self.appAdminGroupModal.forEach(x => {
            if (x.applicationId === self.selectedAppId && grpsOfUser.some(y => y.id === x.groupId)) {
              self.admingrpmodalfirstsubgrpidlist = self.admingrpmodalfirstsubgrpidlist.concat(x.subGroupId)
            }
          })
        }
        var adminGroupsArrtemp = response.data.map(function(i) {
          return i.subGroupId
        })
        adminGroupsArr = adminGroupsArrtemp.reduce((a, b) => a.concat(b), []);
        self.indieGroupsAdministered = adminGroupsArr.filter(function (item, pos) {
          if (item.indexOf('~~~') > -1 && adminGroupsArr.indexOf(item) === pos) {
            return item
          }
        })
        storage.set('MasterIndependentGroupsAdministered', self.indieGroupsAdministered)
        adminGroupsArr = adminGroupsArr.map(function(y) {
          if (y.indexOf('~~~') > -1) {
            return y.split('~~~')[0]
          } else {
            return y
          }
        })
        adminAppsArr = response.data.map(function(i) {
          return i.applicationId
        })
        storage.set('adminConfigMaster', JSON.stringify(response.data))
        storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
        storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
        var adminConfig = adminGroupsArr
        // var adminConfigMaster = response.data
        setTimeout(function() {
          if (adminConfig.length === 0) {
            self.loading = false
            return false
          }
          idmApi.getActiveAppNames(`${apiUrl}/auth/apps/${storage.get('cf-user').sub}`).then(function (response) {
            self.mountAfterApps(response)
          }).catch(err => {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          })
        }, 300);
      },
      mountAfterApps(response) {
        var self = this
        var tempStack = []
        var groupsOfUser = JSON.parse(storage.get('grpsOfUser'))
        var adminConfigMaster = JSON.parse(storage.get('adminConfigMaster'))
        response.data.map(function (app) {
          for (var n = 0; n < groupsOfUser.length; n++) {
            for (var m = 0; m < adminConfigMaster.length; m++) {
              if (adminConfigMaster[m].groupId === groupsOfUser[n].id && app.name !== 'bookmark') {
                self.selectedAppId = adminConfigMaster[m].applicationId
                for (var o = 0; o < response.data.length; o++) {
                  if (response.data[o].id === adminConfigMaster[m].applicationId) {
                    self.appList.push(response.data[o])
                    self.uniqueAppList = self.appList.filter((app, index, self) => self.findIndex(t => t.id === app.id) === index)
                  }
                }
                tempStack.push(groupsOfUser[n].id)
              }
            }
          }
        })
        storage.set('email', response.data[0]._embedded.user.profile.login ? response.data[0]._embedded.user.profile.login : response.data[0]._embedded.user.profile.email)
        self.grouplist = self.uniqueAppList.filter(function (item) {
          idmApi.getGroupsByAppId(`${apiUrl}/auth/apps/${item.id}/groups`).then(function (response) {
            self.mountAfterGroups(response, item)
          }).catch(err => {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          })
          if (item.name !== 'bookmark') {
            let temp = self.adminConfigFiltered.filter(app => app.applicationId === item.id)
            if (temp.length > 1) {
              temp.forEach(val => {
                let obj = Object.create(item)
                obj.groupId = val.groupId;
                obj.adminGroupName = val.adminGroupName;
                self.userAppList.push(obj)
              })
            } else {
              self.userAppList.push(item)
            }
            return item
          }
        })
        self.grouplist.map(x => (x.brand = (adminConfigMaster.filter(y => y.applicationId === x.id)[0].brand)))
        self.adminToBrands = [...new Set(self.grouplist.map(z => z.brand))]
        setTimeout(function() {
          var lis = self.appAdminGroupModal.filter(x => self.selectedAppId === x.applicationId)
          if (lis.length > 0) {
            self.selectedGroupId = ((lis[0].subGroupId)[0]).split('~~~')[0] // flist[0].id
          } else {
            self.selectedGroupId = ''
          }
        }, 2000);
      },
      mountAfterGroups(response, item) {
        var self = this
        var glist = response.data
        var adminConfig = JSON.parse(storage.get('adminConfigJSON'))
        var arr = response.config.url.split('/')
        glist.map(obj => {
          obj.appId = arr[arr.length - 2]
          return obj
        });
        Vue.set(self.appGroupMap, item.id, glist)
        for (var q = 0; q < glist.length; q++) {
          if (item.name !== 'bookmark') {
            self.adminAppsArray.push(glist[q])
          }
          if (adminConfig.indexOf(glist[q].id) > -1) {
            self.adminTo.push(glist[q].appId)
          }
        }
        self.loading = false;
      },
      eventResetSuccess() {
        var self = this
        self.removeAllNotifications()
        self.resetSuccess = true
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      },
      eventUpdateToggle(arr) {
        var self = this
        window.scrollTo(0, 0);
        self.indieGroupsForNewUser = []
        self.indieGroupsAdministered = storage.get('MasterIndependentGroupsAdministered')
        self.removeAllNotifications()
        self.clearAddUserFields()
        self.updateToggle = true
        self.addUserFirstName = arr[0]
        self.addUserLastName = arr[1]
        self.addUserPrimaryEmail = self.reverseTransformEmail(arr[2])
        if (self.addUserPrimaryEmail.toLowerCase().indexOf('@identity-deprecated.mycargill.com') > 0 || self.addUserPrimaryEmail.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
          var bcode = self.addUserPrimaryEmail.substring(2, 5)
          self.brand = brandDetails.data.filter(n => n.brandCode === bcode)[0].brandName.toLowerCase()
        } else {
          self.brand = 'cargill'
        }
        self.editUserId = arr[3]
        self.isAzureORInternalIdentities = arr[4]
        self.isEdit = arr[5]
        self.initiateUpdateUserView(arr[3])
        self.getFactorsOfUser(arr[3])
      },
      reverseTransformEmail(em) {
        if (em.toLowerCase().indexOf('@identity-deprecated.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
          em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1)
        }
        return em
      },
      eventSearchCleared(arr) {
        var self = this
        self.loading = true
        setTimeout(function() {
          self.selectedGroupId = ((self.appAdminGroupModal.filter(x => self.selectedAppId === x.applicationId)[0].subGroupId)[0]).split('~~~')[0]
          // console.log("selected group initial" + self.selectedGroupId)
          self.loading = false
        }, 2000);
      },
      eventDeactivateSuccess(email) {
        var self = this
        self.removeAllNotifications()
        self.deactivateSuccess = true
        self.activatedemail = email
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      },
      eventActivateSuccess(email) {
        var self = this
        self.removeAllNotifications()
        self.activateSuccess = true
        self.activatedemail = email
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      },
      eventDeleteSuccess(email) {
        var self = this
        self.removeAllNotifications()
        self.deleteSuccess = true
        self.activatedemail = email
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      },
      /* eventNavTabs(e) {
        $('ul.nav-tabs li').removeClass('active')
        $(this).parent('li').addClass('active')
        $('.tab-content .tab-pane').removeClass('active')
        $('#' + $(this)[0].href.split('#')[1]).addClass('active')
      }, */
      eventCheckbox(e) {
        var self = this
        self.userCreationMessage = ''
        $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg')
        self.addUserGroupIds = []
        var independentGroups = []
        independentGroups = self.appAdminGroupModal.filter(x => x.applicationId === e.target.id)[0].subGroupId
        /* if (e.target.checked) {
          self.loading = true;
          self.indieGroupsForNewUser = self.indieGroupsForNewUser.concat(independentGroups)
          if (self.appGroupMap[e.target.id] === undefined) {
            console.log(e.target.id)
          } else {
            for (var i = 0; i < self.appGroupMap[e.target.id].length; i++) {
              if (self.selectedgroups.length === 0) {
                self.availablegroups.push((self.appGroupMap[e.target.id])[i])
              } else {
                var present = false
                for (var x = 0; x < self.selectedgroups.length; x++) {
                  if ((self.appGroupMap[e.target.id])[i].id === self.selectedgroups[x].id) {
                    present = true
                  }
                }
                if (!present) {
                  var presentInOwnList = false
                  for (var y = 0; y < self.availablegroups.length; y++) {
                    if ((self.appGroupMap[e.target.id])[i].id === self.availablegroups[y].id) {
                      presentInOwnList = true
                    }
                  }
                  if (!presentInOwnList) {
                    self.availablegroups.push((self.appGroupMap[e.target.id])[i])
                  }
                }
              }
            }
            self.loading = false;
          }
        } else {
          for (var j = 0; j < self.appGroupMap[e.target.id].length; j++) {
            self.availablegroups = self.availablegroups.filter(function(item) {
              return item.id !== self.appGroupMap[e.target.id][j].id;
            })
          }
          self.indieGroupsForNewUser = self.indieGroupsForNewUser.filter(x => !independentGroups.includes(x))
        } */
        if (e.target.checked) {
          let val = e.target.value
          let arr = val.split('-')
          let currObj = self.appAdminGroupModal.find(y => y.applicationId === e.target.id);
          if (arr[1] !== "undefined") {
            currObj = self.appAdminGroupModal.find(y => y.applicationId === e.target.id && y.groupId === arr[0]);
          }
          currObj.subGroupId.forEach(currGrp => {
            if (self.selectedgroups.some(group => group.id === currGrp)) {
              return;
            }
            if (currGrp.indexOf("~~~") > -1) {
              let grp = {
                groupId: currGrp,
                isDisabled: currObj.subGroupsMap[currGrp]
              }
              self.indieGroupsForNewUser.push(grp)
            } else {
              self.appGroupMap[e.target.id].forEach(grp => {
                if (grp.id === currGrp) {
                  grp.isDisabled = currObj.subGroupsMap[currGrp];
                  self.availablegroups.push(grp)
                }
              })
            }
          })
        } else {
          for (var j = 0; j < self.appGroupMap[e.target.id].length; j++) {
            self.availablegroups = self.availablegroups.filter(function(item) {
              return item.id !== self.appGroupMap[e.target.id][j].id;
            })
          }
          self.indieGroupsForNewUser = self.indieGroupsForNewUser.filter(x => !independentGroups.includes(x.groupId))
        }
        var textinputs = document.querySelectorAll('.input-checkbx');
        var empty = [].filter.call(textinputs, function(el) {
          return el.checked
        });
        if (empty.length === 0) {
          self.checkedAppBrand = ''
          self.brand = ''
          self.selectedgroups = []
        } else {
          self.checkedAppBrand = self.grouplist.filter(x => (x.id === e.target.id)).length > 0 ? self.grouplist.filter(x => (x.id === e.target.id))[0].brand : 'cargill'
          self.brand = self.checkedAppBrand.toLowerCase()
        }
      },
      eventSelect(e) {
        var self = this
        self.userCreationMessage = ''
        $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg')
      },
      eventInput(e) {
        var self = this
        self.userCreationMessage = ''
        $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg')
      },
      eventBody(e) {
        var self = this
        if (!$('div#dropdown').has(e.target).length) {
          self.showDropDown = false
        }
      },
      eventAdminLink(e) {
        var self = this
        self.goToUserManagement()
      },
      eventTimeout() {
        var self = this
        var lis = self.appAdminGroupModal.filter(x => self.selectedAppId === x.applicationId)
        if (lis.length > 0) {
          self.selectedGroupId = ((lis[0].subGroupId)[0]).split('~~~')[0] // flist[0].id
        } else {
          self.selectedGroupId = ''
        }
      },
      eventHandlers() {
        var self = this
        self.$root.$on('resetsuccess', function () {
          self.eventResetSuccess()
        })
        self.$root.$on('updatetoggle', function (arr) {
          self.eventUpdateToggle(arr);
        })
        self.$root.$on('searchcleared', function (arr) {
          self.eventSearchCleared(arr)
        })
        self.$root.$on('deactivatesuccess', function (email) {
          self.eventDeactivateSuccess(email)
        })
        self.$root.$on('activatesuccess', function (email) {
          self.eventActivateSuccess(email)
        })
        self.$root.$on('deletesuccess', function (email) {
          self.eventDeleteSuccess(email)
        })
        /* $(document).on('click', 'ul.nav-tabs li a', function (e) {
          self.eventNavTabs(e)
        }) */
        $(document).on('change', '.input-checkbx', function (e) {
          self.eventCheckbox(e)
        })
        $(document).on('change', 'select', function (e) {
          self.eventSelect(e)
        })
        $(document).on('input', 'input', function (e) {
          self.eventInput(e)
        })
        $(document).on('click', 'body', function (e) {
          self.eventBody(e)
        })
        $(document).on('click', '#adminLink', function (e) {
          self.eventAdminLink(e)
        })
        setTimeout(function() {
          self.eventTimeout()
        }, 2000);
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      deepcopy(items) {
        var itemsCopy = []
        itemsCopy = items.slice(0);
        return itemsCopy
      },
      isAlreadyPresent(id, index) {
        var self = this
        return self.appList.slice(0, index).filter(x => x.id === id).length > 0
      },
      isPresentInSelectedGroups(gid) {
        var self = this
        // console.log(gid)
        // console.log(self.selectedGroupsOutsideAdmin)
        var ispresentr = self.selectedGroupsOutsideAdmin.filter(x => x.id === gid)
        var ispresentl = self.selectedgroups.filter(x => x.id === gid)
        return (ispresentr.length > 0 || ispresentl.length > 0)
      },
      checkAllowedSubGroup(appid, subgrpid) {
        // var self = this
        var admincfg = JSON.parse(storage.get('adminConfigMaster'))
        var grpsOfUser = JSON.parse(storage.get('grpsOfUser'))
        var configsforappid = []
        if (appid !== 'all') {
          configsforappid = admincfg.filter(x => x.applicationId === appid)
        } else {
          configsforappid = admincfg
        }
        var listofsubgroupsallowed = []
        for (var i = 0; i < configsforappid.length; i++) {
          for (var j = 0; j < grpsOfUser.length; j++) {
            if (configsforappid[i].groupId === grpsOfUser[j].id) {
              // console.log('has access to all subgroups under' + grpsOfUser[j].id)
              listofsubgroupsallowed = listofsubgroupsallowed.concat(configsforappid[i].subGroupId)
            }
          }
        }
        // console.log('subgroupsallowed')
        // console.log(listofsubgroupsallowed)
        var ispresent = 0
        if (subgrpid !== undefined && subgrpid !== null) {
          ispresent = listofsubgroupsallowed.filter(n => n.indexOf(subgrpid) > -1).length
        }
        return ispresent > 0
      },
      storeCustomerTaxId() {
        this.$store.commit('setCustomerTaxId', this.customerTaxId);
      },
      filterApp: function(e) {
        var self = this
        self.loading = true
        setTimeout(function() {
          var lenn = self.appAdminGroupModal.filter(x => x.applicationId === self.selectedAppId).length
          if (lenn > 0) {
            let grpsOfUser = JSON.parse(storage.get('grpsOfUser'));
            self.admingrpmodalfirstsubgrpidlist = []
            // self.admingrpmodalfirstsubgrpidlist = ((self.appAdminGroupModal.filter(x => x.applicationId === self.selectedAppId))[0]).subGroupId
            self.appAdminGroupModal.forEach(x => {
              if (x.applicationId === self.selectedAppId && grpsOfUser.some(y => y.id === x.groupId)) {
                self.admingrpmodalfirstsubgrpidlist = self.admingrpmodalfirstsubgrpidlist.concat(x.subGroupId)
              }
            })
            self.selectedGroupId = self.admingrpmodalfirstsubgrpidlist[0]
            if (self.selectedGroupId.indexOf("~~~") > -1) {
              self.selectedGroupId = self.selectedGroupId.split("~~~")[0]
            }
          }
          // self.selectedGroupId = ((self.appAdminGroupModal.filter(x => self.selectedAppId === x.applicationId)[0].subGroupId)[0]).split('~~~')[0] // flist[0].id
          // console.log("selected group initial" + self.selectedGroupId)
          self.loading = false
        }, 2000);
      },
      filterGroup: function(e) {
      },
      validEmail: function(email) {
        var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        return re.test(email);
      },
      validateAddUser: function(e) {
        var self = this
        this.addUserValidations = [];
        if (!this.addUserFirstName) {
          this.addUserValidations.push(self.user_lang['firstnamereq']);
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (!this.addUserLastName) {
          this.addUserValidations.push(self.user_lang['lastnamereq']);
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (!this.addUserPrimaryEmail) {
          this.addUserValidations.push(self.user_lang['emailreq']);
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (!this.validEmail(this.addUserPrimaryEmail)) {
          this.addUserValidations.push(self.user_lang['emailinvalid'] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
          this.addUserValidations.push(self.user_lang['emailinvalid'] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (internalUserDomains.filter(x => x.toLowerCase().indexOf(self.addUserPrimaryEmail.split('@')[1].toLowerCase()) > -1).length > 0) {
          this.addUserValidations.push(self.user_lang['emailinvaliddomain']);
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else if (this.selectedgroups.length === 0 && this.selectedIndiegroups.length === 0) {
          this.addUserValidations.push(self.user_lang['atleastonegroup']);
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        } else {
          this.addUserValidations = []
        }
        return !this.addUserValidations.length
      },
      /* encodeBrandMailId: function (id, brand) {
        var self = this
        if (brand.toLowerCase() === 'cargill') {
          return id
        } else {
          var brandcode = self.brandDetails.data.filter(n => n.brandName.toLowerCase() === brand.toLowerCase())[0].brandCode
          // var a = ((id.indexOf('@') + 1) < 10 ? '0' + (id.indexOf('@') + 1) : (id.indexOf('@') + 1))
          var b = (id.split('@').join('#') + '@identity.cargill.com')
          return brandcode + b
        }
      },
      generateSecEmail: function (id, brand) {
        if (brand.toLowerCase() === 'cargill') {
          return id
        } else {
          return 'ASHOK_PARAKKAL@CRGL-THIRDPARTY.COM'
        }
      }, */
      displayActivateModal: function() {
        let self = this;
        if (self.validateAddUser()) {
          self.userCreationMessage = ''
          $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg')
          self.addUserGroupIds = [];
          self.dxpList = [];
          self.nonDxpList = [];
          self.loading = true;
          self.selectedgroups.map((grpObj) => {
            this.addUserGroupIds.push(grpObj.id);
          });
          self.selectedIndiegroups.map((grpObj) => {
            this.addUserGroupIds.push(grpObj.split('~~~')[0]);
          });
          let groupsToPush = this.addUserGroupIds.slice(0);
          groupsToPush.push(onecargillapplicationgroupid);
          groupsToPush = groupsToPush.join(',');
          idmApi.getListOfSuperUserApps(`${apiUrl}/auth/apps`, self.email).then(function (response) {
            self.appGrpList = response.data;
            idmApi.getDxpDetails(`${apiUrl}/auth/users/userMapGroup?groupId=${groupsToPush}`).then(function (response) {
              if (response.data && response.data.dxpAppList) {
                response.data.dxpAppList.map((grp) => {
                  self.appGrpList.map((grpObj) => {
                    if (grpObj.id === grp) {
                      self.dxpList.push({
                        id: grpObj.id,
                        label: grpObj.label
                      });
                    }
                  });
                });
              }
              if (response.data && response.data.nonDxpAppList) {
                response.data.nonDxpAppList.map((grp) => {
                  self.appGrpList.map((grpObj) => {
                    if (grpObj.id === grp) {
                      self.nonDxpList.push({
                        id: grpObj.id,
                        label: grpObj.label
                      });
                    }
                  });
                });
              }
              if (self.dxpList.length > 0 && self.nonDxpList.length > 0) {
                $('.dxpNewmodal').modal('show');
              } if (self.dxpList.length === 0 && self.nonDxpList.length > 0) {
                self.createUser("0");
              } if (self.dxpList.length === 1 && self.nonDxpList.length === 0) {
                self.createUser(self.dxpList[0].id);
              } if (self.dxpList.length > 1 && self.nonDxpList.length === 0) {
                $('.newdxpmodal1').modal('show');
              }
              self.loading = false;
            });
          }).catch(err => {
            $('.dxpNewmodal').modal('hide');
            $('.dxpNewmodal1').modal('hide');
            self.loading = false;
            console.log(err)
          })
        }
      },
      closeModal: function(modalName) {
        $(modalName).modal('hide');
      },
      sendDxpNewInvite: function() {
        let selectedVal = $("input[name='activation']:checked").val();
        this.createUser(selectedVal);
      },
      createUser: function(appId) {
        var self = this;
        let url = "";
        self.addUserGroupIds = []
        if (self.validateAddUser()) {
          self.userCreationMessage = '';
          $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg')
          self.loading = true;
          /* const addUserJSON = {"headers": {"request-type": "adduser", "first-name": this.addUserFirstName,
          "last-name": this.addUserLastName, "email-address": this.addUserPrimaryEmail, "groupid": this.addUserGroupIds[0], "locale": this.prefLang}} */
          for (var n = 0; n < self.selectedgroups.length; n++) {
            if (self.selectedgroups[n] &&
            self.selectedgroups[n]['_embedded'] &&
            self.selectedgroups[n]['_embedded']['group'] &&
            self.selectedgroups[n]['_embedded']['group']['profile'] &&
            self.selectedgroups[n]['_embedded']['group']['profile']['name'] &&
            (self.selectedgroups[n]['_embedded']['group']['profile']['name']).toLowerCase().trim() !== 'everyone') {
              this.addUserGroupIds.push(self.selectedgroups[n].id);
            }
          }
          for (var m = 0; m < self.selectedIndiegroups.length; m++) {
            this.addUserGroupIds.push(self.selectedIndiegroups[m].split('~~~')[0])
          }
          var groupsToPush = this.addUserGroupIds.slice(0)
          groupsToPush.push(onecargillapplicationgroupid)
          let data = {
            "profile": {
              "firstName": this.addUserFirstName,
              "lastName": this.addUserLastName,
              "email": this.addUserPrimaryEmail,
              "locale": this.prefLang,
              "login": this.addUserPrimaryEmail,
              "secondEmail": this.addUserSecondaryEmail
            },
            "groupIds": groupsToPush,
            "brand": this.brand
          }
          if (this.brand.toLowerCase() !== 'cargill') {
            var brandGroup = brandDetails.data.filter(n => n.brandName.toLowerCase() === self.brand.toLowerCase())[0].brandGroup
            groupsToPush.push(brandGroup)
          }
          self.userAlreadyExists = false
          self.existingUserObj = {};
          if (appId === "0") {
            url = `${apiUrl}/auth/users/userNew`;
          } else {
            url = `${apiUrl}/auth/users/userNew?appId=${appId}`;
          }
          idmApi.createUser(url, data)
            .then(function (response) {
              self.isShow = false;
              self.loading = false;
              $('.dxpNewmodal').modal('hide');
              $('.dxpNewmodal1').modal('hide');
              self.userCreationMessage = self.user_lang.usercreated
              $('#userCreationMessage').removeClass('error-bg').addClass('success-bg')
              $('html, body').animate({ scrollTop: 0 }, 'fast');
            }).catch(err => {
              $('.dxpNewmodal').modal('hide');
              $('.dxpNewmodal1').modal('hide');
              self.loading = false;
              console.log("create Insert CF Error: ", err);
              if (err.response.status === 403 || err.response.status === 401) {
                self.addUserValidations.push(err.response.data.errorSummary);
              }
              if (err.response.status === 400) {
                if (err.response.data && err.response.data.errorCauses && err.response.data.errorCauses.length > 0 && (err.response.data.errorCauses[0].errorSummary.indexOf('Does not match required pattern') > -1 || err.response.data.errorCauses[0].errorSummary.indexOf('Username must be in the form of an email address') > -1)) {
                  var s = err.response.data.errorCauses[0].errorSummary
                  self.addUserValidations.push(s.charAt(0).toUpperCase() + s.slice(1) + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
                  $('html, body').animate({ scrollTop: 0 }, 'fast');
                } else {
                  self.loading = true;
                  idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${self.addUserPrimaryEmail}`).then(function (response) {
                    self.existingUserObj = response.data
                    idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${response.data.id}/groups`).then(function (response) {
                      self.loading = false;
                      for (var m = 0; m < response.data.length; m++) {
                        if (self.containsObject((response.data)[m], self.adminAppsArray)) {
                          self.userAlreadyExists = true
                        }
                      }
                      if (!self.userAlreadyExists) {
                        self.addUserValidations.push(self.user_lang.partofokta);
                        $('html, body').animate({ scrollTop: 0 }, 'fast');
                      } else if (self.userAlreadyExists && self.existingUserObj.status === 'DEPROVISIONED') {
                        self.userAlreadyExists = false
                        self.addUserValidations.push(self.user_lang.userdeactive);
                        $('html, body').animate({ scrollTop: 0 }, 'fast');
                      }
                    }).catch(err => {
                      self.loading = false;
                      console.log(err)
                    });
                  }).catch(err => {
                    self.loading = false;
                    console.log(err)
                  });
                  self.addUserValidations.push(self.user_lang.errorcreatinguser);
                  $('html, body').animate({ scrollTop: 0 }, 'fast');
                }
              }
              // self.userCreationMessage = self.user_lang.errorcreatinguser
              // $('#userCreationMessage').removeClass('success-bg').addClass('error-bg')
            })
        }
      },
      handleSelect(options) {
      },
      removeFromSelectedGroup(id) {
        for (var i = 0; i < this.selectedgroups.length; i++) {
          if (this.selectedgroups[i].id === id) {
            this.availablegroups.push(this.selectedgroups.splice(i, 1)[0])
          }
        }
      },
      addToSelectedGroup(id) {
        for (var i = 0; i < this.availablegroups.length; i++) {
          if (this.availablegroups[i].id === id) {
            if (this.selectedgroups.some(grp => grp.id === this.availablegroups[i].id)) {
              this.availablegroups.splice(i, 1)[0]
            } else {
              this.selectedgroups.push(this.availablegroups.splice(i, 1)[0])
            }
          }
        }
      },
      removeFromSelectedIndieGroup(id, fromList) {
        var self = this
        if (fromList === 'indie') {
          for (var i = 0; i < this.selectedIndiegroups.length; i++) {
            if (this.selectedIndiegroups[i].indexOf(id) > -1) {
              this.indieGroupsAdministered.push(this.selectedIndiegroups[i])
              this.selectedIndiegroups.splice(i, 1)
              self.loading = true;
              idmApi.unassignUserFromGroup(`${apiUrl}/auth/groups/${id}/users/${self.editUserId}`).then(function (response) {
                self.loading = false;
              }).catch(err => {
                self.loading = false;
                console.log("create Insert CF Error: ", err);
              })
            }
          }
        } else {
          for (var j = 0; j < this.selectedGroupsOutsideAdmin.length; j++) {
            var temp = this.indieGroupsAdministered.filter(q => q.indexOf(id) > -1).length
            if (this.selectedGroupsOutsideAdmin[j].id.indexOf(id) > -1 && temp === 0) {
              this.indieGroupsAdministered.push(this.selectedGroupsOutsideAdmin[j].id + '~~~' + this.selectedGroupsOutsideAdmin[j].profile.name)
              this.selectedGroupsOutsideAdmin.splice(j, 1)
            } else if (this.selectedGroupsOutsideAdmin[j].id.indexOf(id) > -1) {
              this.selectedGroupsOutsideAdmin.splice(j, 1)
            }
            self.loading = true;
            idmApi.unassignUserFromGroup(`${apiUrl}/auth/groups/${id}/users/${self.editUserId}`).then(function (response) {
              self.loading = false;
            }).catch(err => {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            })
          }
        }
      },
      addToSelectedIndieGroup(id) {
        for (var i = 0; i < this.indieGroupsAdministered.length; i++) {
          if (this.indieGroupsAdministered[i].indexOf(id) > -1) {
            this.selectedIndiegroups.push(this.indieGroupsAdministered.splice(i, 1)[0])
            // console.log(this.selectedIndiegroups.length)
          }
        }
      },
      removeAllNotifications() {
        this.userCreationMessage = ''
        this.deactivateSuccess = false
        this.activateSuccess = false
        this.resetSuccess = false
        this.deleteSuccess = false
        this.activatedemail = ''
        this.updatesuccess = false
        this.userAlreadyExists = false
        this.existingUserObj = {}
      },
      clearAddUserFields() {
        this.indieGroupsAdministered = storage.get('MasterIndependentGroupsAdministered')
        this.addUserFirstName = ''
        this.addUserLastName = ''
        this.addUserPrimaryEmail = ''
        this.addUserSecondaryEmail = '';
        this.brand = ''
        this.prefLang = 'en_US'
        this.addUserGroupIds = []
        this.availablegroups = []
        this.selectedgroups = []
        this.selectedIndiegroups = []
        this.selectedGroupsOutsideAdmin = []
        this.rawUserGroups = []
        this.addUserValidations = []
        this.userAlreadyExists = false
        this.existingUserObj = {}
        this.checkedAppBrand = ''
        $('input[type=checkbox]').attr('checked', false)
      },
      goToUserManagement() {
        var self = this
        self.showDateFields = false
        self.isEdit = false
        self.noFactorSelected = false
        $('#toggle-arrow').removeClass('fa fa-angle-down').addClass('fa fa-angle-right')
        $('#toggle-mfa-arrow').removeClass('fa fa-angle-down').addClass('fa fa-angle-right')
        $('#toggle-data').hide()
        $('#toggle-mfa-data').hide()
        self.indieGroupsForNewUser = []
        this.isShow = false
        this.updateToggle = false
        self.$root.$emit('refreshuserlist')
        this.indieGroupsAdministered = storage.get('MasterIndependentGroupsAdministered')
      },
      toggleDateFields() {
        var self = this
        $('#toggle-data').slideToggle()
        $('#toggle-arrow').toggleClass("fa-angle-right fa-angle-down")
        self.showDateFields = true
      },
      toggleMFAField() {
        var self = this
        self.noFactorSelected = false
        $('#toggle-mfa-data').slideToggle()
        $('#toggle-mfa-arrow').toggleClass("fa-angle-right fa-angle-down")
        self.showDateFields = true
      },
      transformText(text) {
        var name = text.toLowerCase().indexOf('okta') > -1 ? this.user_lang.verify : this.user_lang.authentication;
        return text.indexOf('sms') > -1 ? text.toUpperCase() + " " + name : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() + " " + name;
      },
      isAdminAuthorizedForProfile() {
        var self = this
        self.loading = true
        console.log(self.isAzureORInternalIdentities)
        if (self.addUserPrimaryEmail.toLowerCase().indexOf('@cargill.com') > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf('@crgl-thirdparty.com') > -1) {
          if (!self.isServiceAccGrpPresent) {
            self.isNameEditable = false
            return;
          }
        }
        // if (self.isAzureORInternalIdentities) {
        //   self.isNameEditable = false
        //   return;
        // }
        let grpsOfUser = JSON.parse(storage.get('grpsOfUser'));
        let grpIds = [];
        grpsOfUser.map((grp) => {
          grpIds.push(grp.id);
        });
        grpIds.join(',');
        idmApi.getDxpDetails(`${apiUrl}/auth/users/mapgroup?adminId=${grpIds}&userId=${self.editUserId}`).then(function (response) {
          if (response.data && (response.data.nonDxpAppList || response.data.dxpAppList)) {
            self.isNameEditable = true
          } else {
            self.isNameEditable = false
          }
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      isAdminAuthorized() {
        var self = this
        self.loading = true
        let grpsOfUser = JSON.parse(storage.get('grpsOfUser'));
        let grpIds = [];
        grpsOfUser.map((grp) => {
          grpIds.push(grp.id);
        });
        grpIds.join(',');
        idmApi.getDxpDetails(`${apiUrl}/auth/users/mapgroup?adminId=${grpIds}&userId=${self.editUserId}`).then(function (response) {
          if (response.data && response.data.errorMessage) {
            self.errorMsgForMFA = response.data.errorMessage
            self.isAuthorizedForMFA = false
          } else {
            self.isAuthorizedForMFA = true
          }
          self.loading = false
          $('.mfaresetmodal').modal('show')
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      checkAccess() {
        var self = this
        self.isChecked = $('input[name=mfaReset]:checked').size() > 0
        if (self.isChecked) {
          self.mfaResetSuccess = false
          self.noFactorSelected = false
          console.log($('input[name=mfaReset]:checked').attr('id'))
          self.selectedFactorId = $('input[name=mfaReset]:checked').attr('id')
          self.isAdminAuthorized()
        } else {
          self.noFactorSelected = true
        }
      },
      resetMFA() {
        var self = this
        self.loading = true
        idmApi.deleteSMSFactor(`${apiUrl}/auth/users/${self.editUserId}/factors/${self.selectedFactorId}`).then(function (response) {
          console.log(response)
          self.selectedFactorId = ""
          self.mfaResetSuccess = true
          self.loading = false
          self.getFactorsOfUser(self.editUserId)
          self.toggleMFAField()
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
      },
      getFactorsOfUser(userId) {
        var self = this
        self.loading = true
        self.userFactorList = []
        idmApi.getFactorByUserId(`${apiUrl}/auth/users/${userId}/factors/secure`).then(function (response) {
          self.userFactorList = response.data
          self.loading = false
        }).catch(err => {
          self.loading = false
          console.log(err)
        });
      },
      formatDate(date) {
        var d = date.split('T')
        var time = d[1].split('.')
        var t = time[0].split(':')
        var hh = (t[0] % 12) || 12
        if (hh < 10) {
          hh = "0" + hh
        }
        var mm = t[1]
        var ss = t[2]
        var amOrPm = time[0].split(':')[0] >= 12 ? "PM" : "AM"
        return d[0] + " " + hh + ":" + mm + ":" + ss + " " + amOrPm + " UTC"
      },
      assignDateFields(res) {
        var self = this
        var empty = ""
        self.dateInfo.createdDate = res && res.created ? self.formatDate(res.created) : empty
        self.dateInfo.activatedDate = res && res.activated ? self.formatDate(res.activated) : empty
        self.dateInfo.lastLogin = res && res.lastLogin ? self.formatDate(res.lastLogin) : empty
        self.dateInfo.lastUpdated = res && res.lastUpdated ? self.formatDate(res.lastUpdated) : empty
        self.dateInfo.passwordChanged = res && res.passwordChanged ? self.formatDate(res.passwordChanged) : empty
        self.dateInfo.statusChanged = res && res.statusChanged ? self.formatDate(res.statusChanged) : empty
      },
      initiateUpdateUserView(userId) {
        var self = this
        self.loading = true;
        idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${userId}`).then(function (response) {
          self.loading = false
          self.assignDateFields(response.data)
          // self.isAzureId = response.data.credentials.provider.type.toLowerCase() === 'federation'
          var loc = response.data.profile.locale && response.data.profile.locale.toLowerCase()
          if (response.data.profile.secondEmail) {
            self.addUserSecondaryEmail = response.data.profile.secondEmail;
          }
          if (loc !== undefined && loc !== null && loc.trim() !== '') {
            Object.keys(locale.lang_obj).forEach(function(i) {
              if (loc.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                self.prefLang = i
              }
            })
          } else {
            self.prefLang = 'en_US'
          }
          // console.log("profileLang" + self.prefLang)
        })
        self.loading = true;
        idmApi.getActiveAppNames(`${apiUrl}/auth/apps/${userId}`).then(function (response) {
          self.editUserApps = response.data.filter(function (item) {
            if (item.name !== 'bookmark' && item._embedded.user._links.group !== undefined && item.id !== onecargillappid) {
              return item
            }
          })
        }).catch(err => {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
        idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${userId}/groups`).then(function (response) {
          // self.isServiceAccountGroupMember = response.data.filter(x => x.profile.name.toLowerCase().indexOf('service accounts') > -1).length > 0
          self.initiateAfterGetGroups(response)
        }).catch(err => {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
      },
      initiateAfterGetGroups(response) {
        var self = this
        self.isServiceAccGrpPresent = false;
        for (var k = 0; k < response.data.length; k++) {
          if ((response.data)[k].id === serviceAccountGroupId) {
            self.isServiceAccGrpPresent = true;
          }
          if (self.containsObject((response.data)[k], self.adminAppsArray) && !self.containsObject((response.data)[k], self.selectedgroups)) {
            for (var y = 0; y < self.adminAppsArray.length; y++) {
              if (self.adminAppsArray[y].id === ((response.data)[k]).id) {
                var objG = (response.data)[k]
                objG['appId'] = self.adminAppsArray[y].appId
                objG['isDisabled'] = self.getGroupDisabledVal(objG);
                if (!self.containsObject(objG, self.selectedgroups)) {
                  self.selectedgroups.push(objG)
                }
              }
            }
            // self.selectedgroups.push((response.data)[k])
          } else {
            var tempName = (response.data)[k]._embedded ? (response.data)[k]._embedded.group.profile.name : (response.data)[k].profile.name
            if (!self.containsObject((response.data)[k], self.selectedGroupsOutsideAdmin) &&
            !self.containsObject((response.data)[k], self.selectedgroups) && tempName.toLowerCase().trim() !== 'everyone') {
              self.selectedGroupsOutsideAdmin.push((response.data)[k])
            }
          }
        }
        self.rawUserGroups = self.selectedgroups.slice(0)
        self.isAdminAuthorizedForProfile()
        self.loading = false;
      },
      getGroupDisabledVal(obj) {
        var self = this
        let temp = self.appAdminGroupModal.filter(x => x.applicationId === obj.appId)
        // let disabled = false
        // temp.forEach(grp => {
        //   if (grp.subGroupsMap[obj.id]) {
        //     disabled = true;
        //   }
        // })
        return temp.some(grp => grp.subGroupsMap[obj.id]);
      },
      updateUser() {
        var self = this
        if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
          return false;
        }
        let data = {"profile": { "firstName": self.addUserFirstName, lastName: self.addUserLastName, secondEmail: self.addUserSecondaryEmail }};
        idmApi.updateName(`${apiUrl}/auth/users/updateUser?userId=${self.editUserId}`, data).then(function (response) {
        }).catch(error => {
          console.log(error)
        });
        if (this.selectedgroups.length > 0 || this.selectedIndiegroups.length > 0) {
          for (var u = 0; u < this.selectedIndiegroups.length; u++) {
            // add them newly
            self.loading = true;
            idmApi.assignUserToGroup(`${apiUrl}/auth/groups/${(self.selectedIndiegroups)[u].split('~~~')[0]}/users/${self.editUserId}`).then(function (response) {
              self.loading = false;
            }).catch(err => {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            })
          }
          for (var s = 0; s < this.selectedgroups.length; s++) {
            if (!self.containsObject((this.selectedgroups)[s], this.rawUserGroups)) {
              // add them newly
              self.loading = true;
              idmApi.assignUserToGroup(`${apiUrl}/auth/groups/${(self.selectedgroups)[s].id}/users/${self.editUserId}`).then(function (response) {
                self.loading = false;
              }).catch(err => {
                self.loading = false;
                console.log("create Insert CF Error: ", err);
              })
            }
            if (s === self.selectedgroups.length - 1) {
              setTimeout(function() {
                for (var t = 0; t < self.rawUserGroups.length; t++) {
                  if (!self.containsObject((self.rawUserGroups)[t], self.selectedgroups)) {
                  // delete them
                    self.loading = true;
                    idmApi.unassignUserFromGroup(`${apiUrl}/auth/groups/${(self.rawUserGroups)[t].id}/users/${self.editUserId}`).then(function (response) {
                      self.loading = false;
                    }).catch(err => {
                      self.loading = false;
                      console.log("create Insert CF Error: ", err);
                    })
                  }
                  if (t === self.rawUserGroups.length - 1) {
                    self.goToUserManagement()
                    self.updatesuccess = true
                  }
                }
                if (self.rawUserGroups.length === 0) {
                  self.goToUserManagement()
                  self.updatesuccess = true
                }
              }, 1000);
            }
          }
        } else {
          for (var t = 0; t < this.rawUserGroups.length; t++) {
            if (!self.containsObject((this.rawUserGroups)[t], this.selectedgroups)) {
            // delete them
              self.loading = true;
              idmApi.unassignUserFromGroup(`${apiUrl}/auth/groups/${(this.rawUserGroups)[t].id}/users/${self.editUserId}`).then(function (response) {
                self.loading = false;
              }).catch(err => {
                self.loading = false;
                console.log("create Insert CF Error: ", err);
              })
            }
            if (t === this.rawUserGroups.length - 1) {
              self.goToUserManagement()
              self.updatesuccess = true
            }
          }
          if (this.rawUserGroups.length === 0) {
            self.goToUserManagement()
            self.updatesuccess = true
          }
        }
      },
      containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
          if (list[i].id === obj.id) {
            return true;
          }
        }
        return false;
      },
      isChildren(id) {
        for (var r = 0; r < this.selectedgroups.length; r++) {
          if (this.selectedgroups[r].appId === id) {
            return true
          }
        }
        return false
      },
      goToExistingUser() {
        var self = this
        self.$root.$emit('updatetoggle',
        [self.existingUserObj.profile.firstName, self.existingUserObj.profile.lastName, self.existingUserObj.profile.login, self.existingUserObj.id])
      },
      clearSelectedOptions() {
        var self = this
        $('input[name=bulkUpload]').attr('checked', false)
        self.optionsNotSelected = false
      },
      submitFile(isReinvite) {
        var self = this
        self.clearSelectedOptions()
        if (isReinvite) {
          self.loading = true;
          let adminsGroupIds = []
          JSON.parse(storage.get("grpsOfUser")).forEach(function(x) {
            adminsGroupIds.push(x.id)
          })
          let adminEmail = storage.get("email")
          let formData = new window.FormData();
          formData.append('file', this.file);
          formData.append('adminsGroupIds', adminsGroupIds);
          formData.append('adminEmail', adminEmail);
          $('.bulkReinviteModal').modal('hide')
          axios.post(`${apiUrl}/auth/uploadusers/reInvite`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(function(response) {
            self.loading = false;
            console.log(response.data)
            self.reInviteMessage = response.data.Status
            $('.bulkReinviteMessageModal').modal('show')
            self.clearFile()
          }).catch(error => {
            self.loading = false;
            console.log(error.response)
            $('.bulkReinviteModal').modal('hide')
            if (error.response.status === 406) {
              self.reInviteMessage = "Maximum users allowed is 50"
            } else if (error.response.status === 400) {
              self.reInviteMessage = error.response.data.Status
            } else {
              self.reInviteMessage = 'Something went wrong. please check the data and try again';
            }
            $('.bulkReinviteMessageModal').modal('show')
            self.clearFile()
          })
        } else {
          self.loading = true;
          var adminToGroups = this.appAdminGroupModal.filter(x => [...new Set(this.adminTo)].indexOf(x.applicationId) > -1).map(x => x.subGroupId).flat(1).map(x => x.split('~~~')[0]).join(',')
          let formData = new window.FormData();
          formData.append('file', this.file);
          formData.append('groupids', adminToGroups);
          $('.bulkCreateModal').modal('hide')
          axios.post(`${apiUrl}/auth/uploadusers`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(function(response) {
            self.loading = false;
            console.log(response.data)
            if (response.data && response.data.length > 0) {
              var n = "Submitted Successfully.\n\nBelow Users are not successfully processed:\n\n" + response.data.map(function(i) { return "Email: " + i.email + "\nError: " + i.error }).join('\r\n\n')
              window.alert(n)
            } else {
              window.alert('Users are created Successfully!');
            }
            self.clearFile()
          })
          .catch(function(e) {
            self.loading = false;
            $('.bulkCreateModal').modal('hide')
            if (e.response && e.response.status === 406) {
              window.alert(e.response.data);
            } else {
              window.alert('Something went wrong. please check the data and try again');
            }
            self.clearFile()
          });
        }
      },
      handleFileUpload(isReinvite) {
        this.file = isReinvite ? this.$refs.reinviteFile.files[0] : this.$refs.file.files[0];
        var filename = (this.file).name
        if (filename.slice(filename.lastIndexOf('.')).indexOf('xl') === -1) {
          window.alert('Only Excel file type is allowed.');
          this.clearFile()
          this.isExcel = false
        } else {
          this.isExcel = true
        }
      },
      clearFile() {
        this.uploadReady = false
        this.$nextTick(() => {
          this.uploadReady = true
        })
      },
      showBulkUploadWindow() {
        $('.bulkUploadOptionsModal').modal('show')
      },
      openbulkModals() {
        var self = this
        let isChecked = $('input[name=bulkUpload]:checked').size() > 0
        if (isChecked) {
          let selectedId = $('input[name=bulkUpload]:checked').attr('id')
          if (selectedId === "bulkCreate") {
            $('.bulkCreateModal').modal('show')
          } else {
            $('.bulkReinviteModal').modal('show')
          }
          $('.bulkUploadOptionsModal').modal('hide')
        } else {
          self.optionsNotSelected = true
        }
      },
      resetTotalCount() {
        this.reportTotalCount = undefined;
      },
      downloadUsersOfGroupRecursively(nextSet) {
        var self = this
        self.loading = true;
        self.showProgress = true;
        if (nextSet === undefined) {
          nextSet = `/groupReport/${self.selectedGroupId}/users?limit=1000` // 00gc3xttbu7tduAoV0h7
          self.downloadReportSet = []
          console.log("Download Start: " + new Date())
        }
        if (self.reportTotalCount === undefined) {
          idmApi.getGroupStats(`${apiUrl}/auth/groups/${self.selectedGroupId}`).then(res => {
            self.reportTotalCount = res.data._embedded.stats.usersCount
            idmApi.getUserDetailsOfGroup(`${apiUrl}/auth${nextSet}`).then(response => {
              self.loading = false;
              self.downloadReportSet = self.downloadReportSet.concat(response.data)
              nextSet = response.headers.page
              if (self.downloadReportSet.length < self.reportTotalCount && nextSet !== undefined) {
                self.downloadUsersOfGroupRecursively(nextSet)
              } else {
                console.log(self.downloadReportSet.length)
                self.showProgress = false;
                self.jsonToExcel(self.downloadReportSet, 'report', true)
                console.log("Download End: " + new Date())
              }
            }).catch(function(e) {
              self.loading = false;
              self.showProgress = false;
              window.alert('Something went wrong. Try again later!');
              console.log(e);
            });
          })
        } else {
          idmApi.getUserDetailsOfGroup(`${apiUrl}/auth${nextSet}`).then(response => {
            self.loading = false;
            self.downloadReportSet = self.downloadReportSet.concat(response.data)
            nextSet = response.headers.page
            if (self.downloadReportSet.length < self.reportTotalCount && nextSet) {
              self.downloadUsersOfGroupRecursively(nextSet)
            } else {
              console.log(self.downloadReportSet.length)
              self.showProgress = false;
              self.jsonToExcel(self.downloadReportSet, 'report', true)
              console.log("Download End: " + new Date())
            }
          }).catch(function(e) {
            self.loading = false;
            self.showProgress = false;
            window.alert('Something went wrong. Try again later!');
            console.log(e);
          });
        }
      },
      jsonToExcel(JSONData, FileTitle, ShowLabel) {
        JSONData = JSONData ? JSONData : [{"sdf": "sdd"}] // eslint-disable-line
        // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
        var CSV = '';
        // This condition will generate the Label/Header
        if (ShowLabel) {
          var row = "";
          // This loop will extract the label from 1st index of on array
          for (var index in arrData[0]) {
            // Now convert each value to string and comma-seprated
            row += index + ',';
          }
          row = row.slice(0, -1);
          // append Label row with line break
          CSV += row + '\r\n';
        }
        // 1st loop is to extract each row
        for (var i = 0; i < arrData.length; i++) {
          var Row = "";
          // 2nd loop will extract each column and convert it in string comma-seprated
          for (var Index in arrData[i]) {
            Row += '"' + arrData[i][Index] + '",';
          }
          Row.slice(0, Row.length - 1);
          // add a line break after each Row
          CSV += Row + '\r\n';
        }
        if (CSV === '') {
          window.alert("Invalid data");
          return;
        }
        // Generate a file name
        var filename = FileTitle;
        var blob = new Blob(["\uFEFF" + CSV], {
          type: 'text/csv;charset=utf-8;'
        });
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, filename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = window.URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.style = "visibility:hidden";
            link.download = filename + ".csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
    },
    watch: {
      selectedAppId: function () {
        this.searchTerm = '';
      },
      selectedGroupId: function () {
        this.searchTerm = '';
      },
      searchTerm: function () {
        // var ele = document.getElementById("grpdd")
        // ele.value = 'all'
        // console.log(document.getElementById("grpdd").value)
      },
      globalsearch: function () {
        this.searchTerm = '';
      }
    },
    data() {
      return {
        downloadReportSet: [],
        reportTotalCount: undefined,
        appUrl: document.location.href,
        checkedAppBrand: '',
        adminToBrands: [],
        brandDetails: brandDetails,
        admingrpmodalfirstsubgrpidlist: [],
        isAzureORInternalIdentities: false,
        selectedIndiegroups: [],
        indieGroupsAdministered: [],
        appAdminGroupModal: [],
        updateToggle: false,
        resetSuccess: false,
        activateSuccess: false,
        deactivateSuccess: false,
        deleteSuccess: false,
        activatedemail: '',
        isShow: false,
        showDropDown: false,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        lang_def: locale.lang_def,
        addUserClicked: false,
        deactivateForm: false,
        row: {},
        searchTerm: '',
        userrole: '',
        customerTaxId: '',
        combined_name_and_tax_id: '',
        searchUser: '',
        oktauserId: '',
        email: '',
        customers: {},
        loading: false,
        user_lang: {},
        grouplist: [],
        editUserApps: [],
        selectedAppId: '',
        addUserFirstName: '',
        addUserLastName: '',
        addUserPrimaryEmail: '',
        addUserSecondaryEmail: '',
        addUserGroupIds: [],
        addUserValidations: [],
        prefLang: '',
        brand: '',
        userCreationMessage: '',
        adminItem: {
          name: 'Admin',
          displayName: "Administração",
          to: '/Admin'
        },
        listToMultiselect: [],
        availablegroups: [],
        selectedgroups: [],
        appGroupMap: {},
        rawUserGroups: [],
        editUserId: '',
        adminAppsArray: [],
        updatesuccess: false,
        appList: [],
        uniqueAppList: [],
        selectedGroupId: '',
        userAlreadyExists: false,
        loggedInUser: storage.get('email'),
        globalsearch: false,
        adminTo: [],
        selectedGroupsOutsideAdmin: [],
        onecargillusersgroupid: onecargillapplicationgroupid,
        onecargilladmingroupid: onecargilladmingroupid,
        adminType: storage.get('cf-userRole'),
        file: '',
        isExcel: false,
        uploadReady: true,
        dxpList: [],
        nonDxpList: [],
        appGrpList: [],
        hostName: window.location.host,
        indieGroupsForNewUser: [],
        showProgress: false,
        showDateFields: false,
        isEdit: false,
        userFactorList: [],
        isChecked: false,
        selectedFactorId: '',
        errorMsgForMFA: "",
        mfaResetSuccess: false,
        isAuthorizedForMFA: false,
        isNameEditable: false,
        noFactorSelected: false,
        isAzureId: false,
        isServiceAccountGroupMember: false,
        reInviteMessage: '',
        optionsNotSelected: false,
        isServiceAccGrpPresent: false,
        userGroups: [],
        adminConfigFiltered: [],
        userAppList: [],
        dateInfo: {createdDate: '', activatedDate: '', lastLogin: '', lastUpdated: '', passwordChanged: '', statusChanged: ''}
      }
    }
  }
</script>
<style scoped>
  .admintobrand {
    font-weight:bold;
    font-size:20px;
    text-transform:capitalize;
    background: #eee;
    padding-left: 10px;
    display:block;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
    padding: 0;
  }
.custom-select {
	display: inline-block;
	max-width: 100%;
	height: calc(2.50rem + 2px);
	padding: 0.375rem 1.75rem 0.375rem 0.75rem;
	line-height: 1.25;
	background-color: #ececeb;
	vertical-align: middle;
	background-size: 8px 10px;
	border: 1px solid #00524A;
	border-radius: 0;
	-moz-appearance: none;
	-webkit-appearance: none;
}
.card-block {
	background: #eceff1;
}
.user-input {
	width: 100%;
	background: #ffffff;
	color: #333333;
	height: 30px;
}
.user-select {
	color: #333333;
	height: 30px;
}
#userSearch {
	margin: 10px;
}
.good-table th {
	color: #333333 !important
}
.btn-secondary:active {
	background: #007299;
	box-shadow: none;
}
.btn-secondary {
	background: var(--theme-primary);
	color: #ffffff;
}
input {
	width: 130px;
	box-sizing: border-box;
	border: 1px solid var(--theme-primary);
	border-radius: 0;
	font-size: 16px;
	background-color: #f1f1f1;
	background-position: 10px 10px;
	background-repeat: no-repeat;
	padding: 15px 20px;
	height: 50px;
}
.card {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	background-color: #33373D;
	border: 0px solid rgba(0, 0, 0, 0.125);
	border-radius: 0px;
	box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px
		rgba(0, 0, 0, 0.22);
	box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);
}
.card {
	margin-bottom: 1rem;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.card-block1 {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0rem;
}
#searchId {
	box-sizing: border-box !important;
	border: 2px solid #dde3e6 !important;
	border-radius: 0 !important;
	background-color: #fff !important;
	background-position: 10px 10px !important;
	background-repeat: no-repeat !important;
	height: 40px !important;
	margin-bottom: 18px !important;
	margin-left: 30px !important;
}
.filter-label{ width: 150px;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    font-weight: bold;
}
.btn-secondary {
	background-color: var(--theme-primary);;
	border-color: #00433c;
}
.btn-secondary:hover {
	background-color: #00524A;
	border-color: #00433c;
}
.btn {
	padding: 14px 24px;
	border: 0 none;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
}
/* Pills styles */
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#fff;
    color: var(--theme-primary);
    width: 15rem;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 15rem;
}
.nav-pills .nav-link:hover {
    padding: 15px 30px;
    border-top: 1px solid #00524A;
    border-right: 1px solid #00524A;
    border-left: 1px solid #00524A;
    border-bottom: 1px solid var(--theme-primary);
    background-color:#00524A;
    color:#fff;
    width: ;
}
.nav-pills .nav-link.active:hover {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#FFF;
    color: var(--theme-primary);
    width: ;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    background-color:#00524A;
    color: #fff;
}
.nav-tabs .nav-link {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.nav-link:focus, .nav-link:hover {
    text-decoration: none;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575px) {
.nav-pills, .nav-link {
  width: 100%;
}
.nav-item {
  margin: 5px 0 0 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .nav-pills, .nav-link {
  width: 100%;
}
  .nav-item {
    margin: 0 0 0 1px;
}
.nav-link {
    margin: 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
.input-adduser{
    height: initial;
    padding: 5px 15px;
    width: 100%;
	background: #fff;
	margin: 0px !important
}
.input-checkbx, .gsearch{
width: 20px;
height: 20px;
display: inline-block;
}
.preflang{
    width: 100%;
    min-height: 34px;
	}
.success-bg{
    background: #90ee90;
}
.error-bg{
   background: #ffc0cb;
}
.form-control-label{min-width: 120px;font-size:12px}
.wrap-input{display:block;overflow:hidden}
.form-wrap{    margin-bottom: 3px;}
.create-btn{margin-top: 10px;
    height: 40px;
    line-height: 0px;font-size: 12px;float:right;}
.search-icon{margin-top: 10px;
    margin-top: 0px;
    height: 40px !important;
    line-height: 0px;
    padding: 12px 24px 14px 24px;
	margin-bottom: 10px;
    border-radius: 0px;}
.tableContainer{padding: 0px 15px 30px;    overflow-x: auto;}
.input-group{
    width: 100%;
    background: #fff;
    margin: 0px -15px 0p;
    padding: 5px;
    outline: 15px solid #fff;
    /* margin: 0px -15px; */
}
.input-group-btn {max-width:65px}
.sub-group{display: inline-block}
@media (max-width: 1050px) {
  .input-group {
    width:100% !important;
	display: block;
  }
}
@media (max-width: 768px) {
  .sub-group {
    width:100% !important;
	display: block;
  }
  .searchId{max-width: 230px;}
  .filter-text{margin-left: 0px !important}
  .adduser-btn{margin-left: 0px !important}
}
.dropdown div, .dropdown dt {
    margin:0px;
    padding:0px;
}
.dropdown ul {
    margin:0px;
    padding:0px;
}
.dropdown div {
    position:relative;
    margin:0px;
    padding:0px;
}
.dropdown a, .dropdown a:visited {
    color:#fff;
    text-decoration:none;
    outline:none;
    margin:0px;
    padding:0px;
    min-height: 30px;
    border-radius: 3px;
}
.dropdown div a {
    background-color:#4F6877;
    display:block;
    overflow: hidden;
    width:100%;
    margin:0px;
    padding:0px;
}
.dropdown div a span, .multiSel span {
    cursor:pointer;
    display:inline-block;
    margin:0px;
    padding:5px 10px;
}
.dropdown div ul {
    background-color: #4F6877;
    top:1px;
    color:#fff;
    display:none;
    position:absolute;
    width:100%;
    list-style:none;
    height: 100px;
    overflow: auto;
    margin:0px;
    padding:0px;
}
.dropdown span.value {
    display:none;
    border-radius: 3px;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a {
    display:block;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a:hover {
    background-color:#fff;
    margin:0px;
    padding:0px;
}
.selectDropDown{border: 2px solid #dde3e6;height:34px;
    /* border-radius: 3px; */
    cursor: pointer;
    background: #fff;
	width: 100%;}
#checkboxlist{position: relative;
    margin-top: 0px;
	background:#fff;
	border: 1px solid #ccc;
	min-width: 200px;}
.dd-list-item:hover{background:#fff}
button {background:var(--theme-primary) !important}
.adduser-btn{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;}
input, select{
background: #fff!important;
    border: 2px solid #dde3e6!important;  
	padding: 9px !important;
    font-size: 14px !important;}
.bc{font-size:10px;font-weight:bold;}
.bc-adduser{font-size:10px;font-weight:bold;margin:15px}
.bc-nav:hover{text-decoration:underline; cursor:pointer}
.user-creds{background:#fff;padding: 7px 15px 15px;
    margin-bottom: 12px;}
.bb0{border-bottom:0px !important}
.add-group{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.remove-group{color:#d80842;font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.group-div{border:2px solid #eceff1;padding: 3px 10px;}
.group-name{display: inline-block;width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
.usercreateinfo{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;font-size: 14px;}
@media screen and (max-width: 767px) {
.main-content{padding-top:25px}
.main-content{padding-left:0px}
}
@media screen and (min-width: 768px) {
.main-content{padding-top:0px}
.main-content{padding-left:200px}
}
@media screen and (min-width: 991px) {
.search-bar-wrapper{width: 100%}
.search-bar-select{}
}
@media screen and (max-width: 991px) {
.search-bar-wrapper{}
.search-bar-select{}
}
.cancel-btn{    float: right;cursor:pointer;
    display: block;
    padding: 18px 30px;}
.disabled{pointer-events:none;opacity:0.6;}
.searchinfotext {
    position: absolute;
    top: 68px;
    font-size: 12px;
    z-index: 999;
	color: #8c8c8c;
}
@media all and (-ms-high-contrast:none)
{
.input-adduser {
  height: auto !important;
}
}
.report-link{
    font-weight: bold;
    float: right;
    text-decoration: underline;
    font-size: 16px;
    color: #658d1b;
	cursor:pointer;
}
button.close {
  background: transparent !important;
}
.dxpNewmodal input[type=radio] {
  width: 13px !important;
  height: 13px !important;
}
.row.date-field-edit {
  padding: 0px 20px;
}
.date-value-edit {
  font-size: 14px;
}
.separator {
  line-height: 18px;
  padding-right: 5px;
}
.date-info {
  padding: 0px 5px 0px 2px;
  font-size: 12px;
}
.mfa-list {
  padding: 0px 10px;
}
.validation-mfa {
  padding: 0px 10px 10px;
  font-size: 14px;
  color: #ff0000;
}
.mfa-btn {
  font-size: 12px;
  height: 35px;
  margin: 5px 10px;
  line-height: 0;
  padding: 10px 15px;
}
.checkboxgroup {
  display: flex;
  text-align: center;
}
.checkboxgroup label {
  display: inline-block;
}
.bulk-list {
  padding: 5px 10px;
}
.bulk-list:hover {
  text-decoration: underline;
  cursor: pointer;
}
.bulk-upload-header {
  background-color: #658d1be3;
  color: #ffffff;
}
.bulk-upload-warning {
  color:#ffa900;
  padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// AdminOld.vue?f1a06180